style= require('./event.styl')
- var event = this.event
if event
  .row.main(
    (click)=this.setState('main'),
    class={active: event.name && state.state === 'main'}
  )
    .event
      ft-icon.default-col.icon(name="events--" + this.match.sport + "--" + event.name)
      = this.eventName(event.name)
    if !match.isEsports
      .shirt= event.player && event.player.shirt + '.'
      .player= event.player && event.player.fullName
    else
      .player= event.player && event.player.customName
each category in subCategories
  .row.sub(
    (click)=this.setState(category),
    class={active: state.state === category}
  )
    .event
      .head
        ft-icon.default-col.icon(name="events--" + this.match.sport + "--" + category)
        = this.eventName(category)
      - var max = this.max(category)
      if max !== 1
        .counter #{this.count(category)}/#{this.max(category)}
    .players
      each event in this.subEvents(category)
        .row
          if !match.isEsports
            .shirt= event.player && event.player.shirt + '.'
            .player= event.player && event.player.fullName
          else
            .player= event.player && event.player.customName
